module.exports = __webpack_public_path__ + "common/tp-featured4-9ad688465989130f55e165339d620c44.svg";